import { render, staticRenderFns } from "./autoria-sede.vue?vue&type=template&id=78d17ca2"
import script from "./autoria-sede.vue?vue&type=script&lang=js"
export * from "./autoria-sede.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports